// Stations transitions
export const A_SECTION_MOUNT = "@stationMountState";
export const A_SECTION_UNMOUNT = "@stationUnmountState";
